






























import Vue from 'vue'
import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue';
import helpPopover from '@/components/Ui/HelpPopover/HelpPopover.vue'
import Poll from '@/models/polls/Poll'
import {MAILING_STATUS_PROGRESS} from '@/constants';
// @ts-ignore
import VcPiechart from 'vc-piechart'
import 'vc-piechart/dist/lib/vc-piechart.min.css'

export default Vue.extend({
  props: {
    scope: {} as () => {poll: Poll},
    options: {}
  },
  components: {
    infoRowsBlock,
    helpPopover,
    VcPiechart
  },
  computed: {
    sentOk (): number {
      return this.scope.poll.getSentOk();
    },
    sentErr (): number {
      return this.scope.poll.getSentErr();
    },
    rcptNum (): number {
      return this.scope.poll.getRcptNum()
    },
    inTurn (): number {
      return this.rcptNum - (this.sentOk + this.sentErr)
    },
    ansTotal (): number {
      return this.scope.poll.getAnsTotal()
    },
    sections (): Array<{value: number, color: string}> {
      let ok = {
        value: Math.ceil(Number(((this.sentOk / this.rcptNum) * 100).toFixed(3))),
        color: '#2AC360'
      }
      let err = {
        value: Math.ceil(Number(((this.sentErr / this.rcptNum) * 100).toFixed(3))),
        color: '#C8C8C8'
      }
      let inTurn = {
        value: Math.ceil(Number(((this.inTurn / this.rcptNum) * 100).toFixed(3))),
        color: '#eeeeee'
      }
      let sections = []
      if (ok.value > 0) sections.push(ok)
      if (err.value > 0) sections.push(err)
      if (inTurn.value > 0) sections.push(inTurn)
      return sections;
    },
    isProgress (): boolean {
      return this.scope.poll.getStatus() === MAILING_STATUS_PROGRESS
    }
  }
})
